<qr-overlay-topbar (close)="close.emit(false)"
  >¿Eliminar movimiento?</qr-overlay-topbar
>
<div class="delete-container">
  <div class="delete-container__body">
    <p>
      ¿Está seguro que desea anular el movimiento
      <span>"{{ movementSelected.concept }}"</span> del
      <span> {{ movementSelected.movementDate | slice : 0 : 10 }}</span> ?
    </p>
  </div>
  <div class="delete-container__footer">
    <qr-button
      class="delete-container__back"
      [config]="buttonCloseAnnul"
      (click)="close.emit(false)"
    ></qr-button>
    <qr-button
      class="delete-container__confirm"
      [config]="buttonConfirmAnnul"
      [isDisabled]="!movementDelete"
      [isLoading]="isDeletingMovement"
      (click)="confirmAnnul()"
    ></qr-button>
  </div>
</div>
